import { createBrowserRouter, Navigate, Outlet, RouterProvider, useRouteError, useMatch, To } from 'react-router-dom';
import { Flex } from '@atoms/layout';
import { ErrorMessage } from '@organisms/dataDisplay';
import { ComingSoonPage } from '@organisms/dataDisplay';
import { MainLayout } from '@templates/mainLayout';
import { ChatwootWrapper } from '@shiftnex/framework/src/components/molecules/supportChat';
import { Component as Dashboard } from '@pages/dashboard';
import { OrganizationSettings, SettingsRoot, OrganizationDetails } from '@pages/settings';
import { Component as ClientsPage } from '@pages/clients';
import { AuthGuard } from '@molecules/auth/authGuard';

export function Routing() {
  return <RouterProvider router={router} />;
}

type RedirectProps = {
  match: string;
  to: To;
};
function Redirect({ match, to }: RedirectProps) {
  const hasMatch = useMatch(match);

  if (hasMatch) {
    // Redirect to default sub page
    return <Navigate to={to} replace={true} />;
  }
  return <Outlet />;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthGuard>
        <ChatwootWrapper>
          <MainLayout>
            <Outlet />
          </MainLayout>
        </ChatwootWrapper>
      </AuthGuard>
    ),
    // TODO: make 404 page
    ErrorBoundary: () => {
      const error = useRouteError();
      console.error('ERROR', error);
      console.log('ERROR', { err: error });
      return (
        <>
          <MainLayout>
            <ErrorMessage error={error as Error} />
          </MainLayout>
        </>
      );
    },
    children: [
      {
        path: '/',
        element: <Redirect match="/" to="/dashboard" />,
      },
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/clients',
        element: <Redirect match="/clients" to="/clients/requests" />,
        children: [
          {
            path: '/clients/requests',
            element: <ClientsPage subpage="requests" />,
          },
          {
            path: '/clients/agencies',
            element: <ClientsPage subpage="agencies" />,
          },
          {
            path: '/clients/facilities',
            element: <ClientsPage subpage="facilities" />,
          },
        ],
      },
      {
        path: '/settings',
        element: <SettingsRoot />,
        children: [
          {
            path: '/settings/general',
            element: <Navigate to="/settings/organization" replace={true} />,
          },
          {
            path: '/settings/organization',
            element: <OrganizationSettings />,
            children: [
              {
                path: '/settings/organization/details',
                element: <OrganizationDetails />,
              },
            ],
          },
          {
            path: '/settings/*',
            element: (
              <Flex justifyCenter alignCenter height="100%" width="100%">
                <ComingSoonPage />
              </Flex>
            ),
          },
        ],
      },
    ],
  },
  {
    path: '/*',
    element: (
      <AuthGuard>
        <MainLayout>
          <ComingSoonPage />
        </MainLayout>
      </AuthGuard>
    ),
  },
  {
    path: '/404',
    element: <ComingSoonPage />,
  },
]);
